import { render, staticRenderFns } from "./material_report.vue?vue&type=template&id=14c581e6&scoped=true"
import script from "./material_report.vue?vue&type=script&lang=js"
export * from "./material_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c581e6",
  null
  
)

export default component.exports